export const AuthReducer = (state, action) => {
    switch (action.type) {
        case "SAVE_USER":
            return {
                ...state,
                user: action.payload
            };
        case "SAVE_TOKEN":
            return {
                ...state,
                token: action.payload,
                isAuthenticated: true
            }
        case "LOGOUT":
            return { user: {}, token: '', isAuthenticated: false };
        default:
            return state;
    }
};